import {Box, Button, Card, Divider, Drawer, Stack, Typography} from "@mui/material";
import {SideNavItem} from "./SideNavItem";
import {useLocation} from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import {useTranslation} from "react-i18next";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsInputComponentOutlinedIcon from "@mui/icons-material/SettingsInputComponentOutlined";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import LanguageIcon from "@mui/icons-material/Language";
import BarChartIcon from "@mui/icons-material/BarChart";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import SearchIcon from "@mui/icons-material/Search";
import GoogleIcon from "@mui/icons-material/Google";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
import HelpIcon from "@mui/icons-material/Help";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CampaignIcon from "@mui/icons-material/Campaign";
import ForumIcon from "@mui/icons-material/Forum";
import {TikTokIcon} from "./icons/Icons";
import {
    ContentCopyOutlined,
    EmojiObjectsOutlined,
    Facebook,
    ManageAccountsRounded,
    NotificationImportant,
} from "@mui/icons-material";
import {LanguageButton} from "./LanguageButton";
import {MainSpeedDial} from "./MainSpeedDial";
import {isLogin} from "../api/authentication/AuthenticationAPI";
import ManageAccountMenu from "./ManageAccountMenu";

export default function SidebarV2() {
    const location = useLocation();
    const {t} = useTranslation([
        "common",
        "sidebar",
        "account",
        "plan",
        "keyword",
        "account",
        "author",
        "site",
        "topic",
    ]);

    const items = [
        {
            title: t("common:homepage"),
            path: "/",
            icon: <DashboardIcon/>,
        },
        {
            title: t("sidebar:settings"),
            icon: <SettingsIcon/>,
            subItems: [
                {
                    title: t("common:general"),
                    path: "/settings/general",
                    icon: <SettingsInputComponentOutlinedIcon/>,
                    premium: true,
                    beta: false,
                },
                {
                    title: t("sidebar:clusters"),
                    path: "/specialization/cluster",
                    icon: <ScatterPlotIcon/>,
                    premium: true,
                },
                {
                    title: t("sidebar:domains"),
                    path: "/settings/domain",
                    icon: <LanguageIcon/>,
                    premium: true,
                    beta: false,
                },
                {
                    title: t("sidebar:alerts"),
                    path: "/settings/alert",
                    icon: <NotificationImportant/>,
                    premium: true,
                    beta: false,
                },
            ],
        },
        {
            title: t("sidebar:content_creation"),
            icon: <EmojiObjectsIcon/>,
            subItems: [
                {
                    title: t("common:trending"),
                    path: "/trending",
                    icon: <TrendingUpIcon/>,
                    beta: true,
                    premium: true,
                },
                {
                    title: t("sidebar:topics"),
                    path: "/specialization/topic",
                    icon: <ContentCopyOutlined/>,
                    beta: true,
                    premium: true,
                },
                {
                    title: t("common:virtual_assistant"),
                    path: "/assistant",
                    icon: <PrecisionManufacturingIcon/>,
                    beta: true,
                    premium: true,
                },
            ],
        },
        {
            title: t("sidebar:brand_management"),
            icon: <ManageSearchOutlinedIcon/>,
            subItems: [
                {
                    title: t("sidebar:keyword_portrait"),
                    path: "/specialization/portrait",
                    icon: <AccessibilityIcon/>,
                    beta: true,
                    premium: true,
                },
                {
                    title: t("sidebar:touch_points"),
                    path: "/specialization/touchpoints",
                    icon: <TouchAppOutlinedIcon/>,
                    beta: true,
                    premium: true,
                },
                {
                    title: t("sidebar:branding"),
                    path: "/specialization/cluster",
                    icon: <AutoAwesomeOutlinedIcon/>,
                    beta: true,
                    premium: true,
                },

				{
					title: t("sidebar:sites"),
					path: "/specialization/sites",
					icon: <NewspaperIcon />,
					beta: true,
					premium: true,
				},
				{
					title: t("sidebar:campaigns"),
					path: "/specialization/campaigns",
					icon: <CampaignIcon />,
					beta: true,
					premium: true,
				},
				{
					title: t("sidebar:whatsnew"),
					path: "/specialization/whatsnew",
					icon: <SearchIcon />,
					beta: true,
					premium: true,
				},
			],
		},
		{
			title: t("sidebar:social_networks"),
			icon: <ConnectWithoutContactIcon />,
			subItems: [
				{
					title: "Facebook",
					path: "/social-network/facebook",
					icon: <Facebook />,
					premium: true,
					beta: true,
				},
				{
					title: "Tiktok",
					path: "/social-network/tiktok",
					icon: (
						<div style={{ width: "24px", height: "24px" }}>
							<TikTokIcon />
						</div>
					),
					premium: true,
					beta: true,
				},
				{
					title: "Forum",
					path: "/social-network/forum",
					icon: <ForumIcon />,
					premium: true,
				},
				{
					title: "Google",
					path: "/social-network/google",
					icon: <GoogleIcon />,
					premium: true,
					beta: true,
				},
			],
		},
		{
			title: t("sidebar:upgrade"),
			path: "/upgrade",
			icon: <ShoppingCartIcon />,
			subItems: [],
		},
		{
			title: t("sidebar:support"),
			icon: <HelpIcon />,
			subItems: [
				{
					title: t("sidebar:guides"),
					path: "/support/tutorial",
					icon: <HelpIcon />,
				},
				{
					title: t("sidebar:feedback"),
					path: "/feedback",
					icon: <EmojiObjectsOutlined />,
				},
			],
		},
	];

	return (
		<Box>
			{/*<MainSpeedDial />*/}
			<Drawer
				anchor="left"
				open
				PaperProps={{
					sx: {
						background:
							"-webkit-linear-gradient(90deg, hsla(216, 97%, 57%, 1) 88%, hsla(216, 97%, 55%, 1) 100%)",
						color: "common.white",
						width: 230,
					},
				}}
				variant="permanent"
			>
				<Box
					sx={{
						alignItems: "center",
						display: "flex",
						justifyContent: "center",
						height: "40px",
						px: "24px",
						py: "12.5px",
					}}
				>
					<Typography
						variant="h4"
						sx={{
							fontFamily: "Lexend Deca",
							fontWeight: 600,
							letterSpacing: "2px",
						}}
					>
						TrendZ
					</Typography>
				</Box>
				<Divider />
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						height: "100%",
					}}
				>
					<Box
						sx={{
							px: 1,
							py: 1.6,
						}}
					>
						<Stack
							spacing={0.6}
							sx={{
								listStyle: "none",
								p: 0,
								m: 0,
							}}
						>
							{items.map((item) => {
								let active = false;
								if (item.path && item.path === location.pathname) {
									active = true;
								} else if (item.subItems && item.subItems.length > 0) {
									active = item.subItems.some(
										(subItem) => location.pathname === subItem.path
									);
								}

								return (
									<SideNavItem
										active={active}
										icon={item.icon}
										key={item.title}
										path={item.path}
										title={item.title}
										beta={item.beta}
										premium={item.premium}
										subItems={item.subItems}
									/>
								);
							})}
						</Stack>
					</Box>
				</Box>
				<Divider />
				<Box
					sx={{
						width: "100%",
						alignItems: "center",
						display: "flex",
						justifyContent: "space-between",
						height: "24px",
						px: "12px",
						py: "8px",
						backgroundColor: "#3182fc",
					}}
				>
					<Typography
						variant="subtitle1"
						sx={{
							fontWeight: 500,
							letterSpacing: "1px",
							fontSize: 13,
						}}
					>
						{t("common:language")}
					</Typography>
					<LanguageButton />
					<Divider orientation="vertical" flexItem />
					{isLogin() && (
						<ManageAccountMenu
							children={
								<ManageAccountsRounded
									sx={{ width: "28px", height: "28px", color: "white" }}
								/>
							}
							items={[
								{ text: t("account:info"), url: "/account/info" },
								{ text: t("common:settings"), url: "/settings" },
								{ text: t("account:logout"), url: "/logout" },
							]}
						/>
					)}
				</Box>
			</Drawer>
		</Box>
	);
}
